module.exports = __webpack_public_path__ + "static/organization_performance_view_360-ed40df7ca6b9c5b9b372c6625cdaab8f.png";